import type { ReactNode } from 'react';
import { Children } from 'react';

type MapFunction<T> = (child: ReactNode, index?: number, children?: ReactNode[]) => T;

function map<T extends ReactNode>(children: ReactNode, mapFn: MapFunction<T>): ReactNode[] {
  return Children.toArray(children).map(mapFn);
}

export default map;
